export default __webpack_public_path__ + "static/media/Flag_of_Spain.d0d17b84.svg";